<template>
	<div class="panel-footer">
		<slot />
	</div>
</template>
